import type { Command, PluginKey, Selection } from "prosemirror-state";
import { DecorationSet } from "prosemirror-view";

import type { ExternalUrlData } from "~/client/generated/schema";

export type ListItemParamType = {
  messageKey: string;
  fn: (pluginKey: PluginKey) => Command;
};

export type SetupListItemsParams = (selection: Selection) => Array<ListItemParamType>;
export type LinkConverterStateType = {
  selection: Selection | null;
  url: string | null;
  externalUrlData: ExternalUrlData | null;
  decorationSet: DecorationSet;
  status: "disabled" | "showing" | "fetching" | "fetched";
  convertFrom: "pasted url" | "url" | "title link" | "link card" | null;
  currentFocusIndex: number;
};
export const linkConverterInitialState: LinkConverterStateType = {
  selection: null,
  url: null,
  externalUrlData: null,
  decorationSet: DecorationSet.empty,
  status: "disabled",
  convertFrom: null,
  currentFocusIndex: 0,
};

const cssClassBase = "richTextEditorLinkConverter";
export const linkConverterCssClasses = {
  container: cssClassBase,
  visible: `${cssClassBase}--visible`,
  list: `${cssClassBase}__list`,
  listItem: `${cssClassBase}__listItem`,
  listItemLink: `${cssClassBase}__listItemLink`,
  focusedListItemLink: `${cssClassBase}__listItemLink--focused`,
  disabledListItem: `${cssClassBase}__listItem--disabled`,
};

export const linkCardClass = "linkCardInNote";
